export function EventListEntry({ children }: { children: React.ReactNode }) {
    return <div className="border-b-solid border-b border-b-slate-grey-mid-light last:border-b-0">{children}</div>;
}
